import { WorkListTasks } from 'components/Rop/WorkListTasks/WorkListTasks'
import { WorkListComments } from 'components/Rop/WorkListComments/WorkListComments'
import { WorkListCreditRequests } from 'components/Rop/WorkListCreditRequests/WorkListCreditRequests'
import { WorkListCalls } from 'components/Rop/WorkListCalls/WorkListCalls'
import { WorkListEstimate } from 'components/Rop/WorkListEstimate/WorkListEstimate'
import { WorkList1C } from 'components/Rop/WorkList1C/WorkList1C'
import WorkListClientNeedsTab from 'components/Rop/WorkListClientNeeds/WorkListClientNeedsTab'
import HistoryOfSelection from 'components/Desktop/HistoryOfSelection'

export const wlViewTabs = [
  {
    label: 'Задачи',
    component: WorkListTasks
  },
  {
    label: 'Комментарии',
    component: WorkListComments
  },
  {
    label: 'Кредитные заявки',
    component: WorkListCreditRequests
  },
  {
    label: 'Звонки',
    component: WorkListCalls
  },
  {
    label: 'РЛ оценки',
    component: WorkListEstimate
  },
  {
    label: '1С и оплата',
    component: WorkList1C
  },
  {
    label: 'Потребности клиента',
    component: WorkListClientNeedsTab
  },
  {
    label: 'История подбора',
    component: HistoryOfSelection
  }
]
